<template>
  <v-col cols="3">
    <naj-input
      :type-id="formFieldType.number"
      :label="local.bankruptcy.requestApplicant.licenceNumber"
      :value.sync="formModel.secretaryLicenceNumber"
      :validates="`required|isValid:${local.bankruptcy.requestApplicant.invalidNumber},${isNumberValid}`"
      :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.applicantDetailsConfirmation}`] && isNotCompleted)"
    ></naj-input>
  </v-col>
</template>

<script>
import { mainRequestAuditFlag } from '@/modules/bankruptcy/helpers/enum';
export default {
  name: 'SecretaryInfo',
  inject: ['$validator'],
  components: {},
  props: {
    formModel: {
      type: Object,
      required: true,
    },
    auditConfirmations: {
      type: Object,
      required: true,
    },
    isNewMode: {
      type: Boolean,
      required: true,
    },
    isViewMode: {
      type: Boolean,
      required: true,
    },
    isEditMode: {
      type: Boolean,
      required: true,
    },
    isNotCompleted: {
      type: Boolean,
      required: true,
    },
    legalCapacityId: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return { mainRequestAuditFlag };
  },
  computed: {
    isNumberValid() {
      return this.formModel.secretaryLicenceNumber !== 0;
    },
  },
  methods: {},
};
</script>

<style lang="scss">
</style>
